module.exports = __webpack_public_path__ + "img/mza-arg.89e2157f.svg";